import { render } from "./TabListing.vue?vue&type=template&id=04b95010&scoped=true"
import script from "./TabListing.vue?vue&type=script&lang=js"
export * from "./TabListing.vue?vue&type=script&lang=js"

import "./TabListing.vue?vue&type=style&index=0&id=04b95010&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b95010"]])

export default __exports__